import {collection, doc, deleteDoc, getDocs, query, where} from "firebase/firestore";
import {QueryClient} from "@tanstack/react-query";
import {db} from "config/firebase";
import {DeleteListParams} from "types/freelo/crud";
import {Board, List} from "@freetech/models/freelo";
import {NestedBoard} from "types/freelo/nested";

export const deleteList = async (params: DeleteListParams, queryClient: QueryClient): Promise<void> => {
  const {boardId, listId} = params;

  queryClient.setQueryData<NestedBoard>(["board", boardId], (oldBoard: NestedBoard | undefined) => {
    if (!oldBoard) return oldBoard;

    return {
      ...oldBoard,
      lists: oldBoard.lists?.filter((list: List) => list.id !== listId) || [],
      listOrder: oldBoard.listOrder?.filter((id: string) => id !== listId) || [],
    };
  });

  try {
    const cardsRef = collection(db, "boards", boardId, "cards");
    const q = query(cardsRef, where("listId", "==", listId));
    const cardsSnapshot = await getDocs(q);

    await Promise.all(cardsSnapshot.docs.map(cardDoc => deleteDoc(doc(db, "boards", boardId, "cards", cardDoc.id))));

    const listRef = doc(db, "boards", boardId, "lists", listId);
    await deleteDoc(listRef);
  } catch (error) {
    queryClient.invalidateQueries({queryKey: ["board", boardId]});
    throw error;
  }
};
